import { Pressable, View } from 'react-native';
import { usePathname, useRouter } from 'expo-router';

import { Button } from '@/components/ui';
import { getLastChatId } from '@/lib/chat/last-conversation';
import { getLastPageId } from '@/lib/navigation/last-page';
import type { SidebarTab } from '@/lib/layout/sidebar-tab';
import { sidebarTabFromPath } from '@/lib/layout/sidebar-tab';

import { SidebarChevronIcon } from './SidebarIcons.web';

type TabDef = {
  id: SidebarTab;
  label: string;
};

const TABS: TabDef[] = [
  { id: 'home', label: 'Home' },
  { id: 'agents', label: 'Agents' },
  { id: 'search', label: 'Search' },
];

type SidebarTabBarProps = {
  onNavigate?: () => void;
  onCollapse?: () => void;
};

export function SidebarTabBar({ onNavigate, onCollapse }: SidebarTabBarProps) {
  const router = useRouter();
  const pathname = usePathname();
  const activeTab = sidebarTabFromPath(pathname);

  async function navigateTab(tab: SidebarTab) {
    onNavigate?.();
    if (tab === 'home') {
      const lastPageId = await getLastPageId();
      if (lastPageId) {
        router.push(`/page/${lastPageId}`);
        return;
      }
      router.push('/app');
      return;
    }
    if (tab === 'agents') {
      const lastChatId = getLastChatId();
      router.push(lastChatId ? `/chat/${lastChatId}` : '/chat');
      return;
    }
    router.push('/search');
  }

  return (
    <View className="flex-row items-center gap-0.5 px-1 py-1">
      <View className="min-w-0 flex-1 flex-row gap-0.5">
        {TABS.map((tab) => {
          const active = activeTab === tab.id;
          return (
            <Button
              key={tab.id}
              className="min-w-0 flex-1 !px-1.5 !py-1 !text-xs"
              label={tab.label}
              size="sm"
              variant={active ? 'primary' : 'secondary'}
              onPress={() => void navigateTab(tab.id)}
            />
          );
        })}
      </View>
      {onCollapse ? (
        <Pressable
          className="flex h-[22px] w-[22px] shrink-0 items-center justify-center rounded"
          onPress={onCollapse}
        >
          <SidebarChevronIcon className="rotate-180" />
        </Pressable>
      ) : null}
    </View>
  );
}
